import cn from 'classnames';

import { Icon } from '@/Components/UI';

import { calculateChamberIndexColor } from '../../../../../lib/calculateChamberIndexColor';
import S from './styles.module.scss';
import { ChamberProps } from './types';

export const ChamberCard: React.FC<ChamberProps> = ({ chamber }) => {
    const chamberIndexColor = calculateChamberIndexColor(chamber.init_value, chamber.spent_value);

    return (
        <div className={S.Card}>
            <div className={S.Info}>
                <div className={cn(S.Index, S[`Index_${chamberIndexColor}`])}>{chamber.index + 1}</div>
                <p className={S.Id}>ID: {chamber.product_udi}</p>
            </div>
            <div className={S.Values}>
                <div className={S.Value}>
                    <Icon name="whiffs-total" size={18} />
                    <span className={S.Count}>{chamber.init_value}</span>
                </div>
                <div className={S.Value}>
                    <Icon name="whiffs-left" size={18} />
                    <span className={S.Count}>{chamber.init_value - chamber.spent_value}</span>
                </div>
                <div className={S.Value}>
                    <Icon name="whiffs-spent" size={18} />
                    <span className={S.Count}>{chamber.spent_value}</span>
                </div>
            </div>
            {chamber.products.length > 0 && (
                <div className={S.Products}>
                    <p>
                        <b>Products:</b> {chamber.products.map((product) => product.name).join(', ')}
                    </p>
                </div>
            )}
        </div>
    );
};
